/**
 * @desc 事件处理-BackToThe
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.BackToThe,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/personal/event/refuse',
    data,
  });
}

export function mock(data: defs.BackToThe): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/personal/event/refuse',
    data,
  });
}
